import { memo } from "react";
import { Col, ListGroup } from "react-bootstrap";

import ChannelComponent from "./ChannelComponent";

import Channel from "../typings/Channel";
import SetState from "../typings/SetState";
import styled from "styled-components";
import ButtonComponent from "./ButtonComponent";

const ChannelsWrapper = styled.div`
  height: 76vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  border-radius: 5px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  background-color: white;

  @media (min-height: 820px) {
    height: 80vh;
  }
`;

const Header = styled.div`
  width: 100%;
  top: 0;
  text-align: center;
  background-color: #222c4a;
  color: white;
  font-weight: 500;
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
`;

const ChannelsList = styled(ListGroup)`
  overflow: auto;
`;

type ChannelGroupProps = {
  channels: Channel[];
  activeChannelId: string;
  onClickChannelHandler: (channel: Channel) => void;
  setDeleteChannelModal: SetState<boolean>;
  setEditChannelModal: SetState<boolean>;
  setCreateChannelModal: SetState<boolean>;
};

const ChannelGroup = ({
  channels,
  activeChannelId,
  onClickChannelHandler,
  setDeleteChannelModal,
  setEditChannelModal,
  setCreateChannelModal,
}: ChannelGroupProps) => {
  let channelComponents = channels.map((channel) => (
    <ChannelComponent
      key={channel._id}
      channel={channel}
      onClickChannelHandler={onClickChannelHandler}
      setDeleteChannelModal={setDeleteChannelModal}
      setEditChannelModal={setEditChannelModal}
      isActive={channel._id === activeChannelId}
    />
  ));

  return (
    <Col md={3}>
      <ChannelsWrapper>
        <Header>Channels list</Header>
        <ChannelsList>{channelComponents}</ChannelsList>
      </ChannelsWrapper>
      <div className="mt-3 d-grid">
        <ButtonComponent onClick={() => setCreateChannelModal(true)} size="lg">
          Create channel
        </ButtonComponent>
      </div>
    </Col>
  );
};

export default memo(ChannelGroup);
